
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequirecde6"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequirecde6"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("8C6MA", function(module, exports) {

$parcel$export(module.exports, "showFormError", function () { return $bfd825a8004fc601$export$5f42f100f752a07c; });
$parcel$export(module.exports, "clearFormError", function () { return $bfd825a8004fc601$export$f96a15e9c4403cf2; });
$parcel$export(module.exports, "showBoxNotice", function () { return $bfd825a8004fc601$export$51d2406237757203; });
/**
 * Inline messages for the static auth pages.
 *
 * These pages are EJS, not the Elm app, so `UI.errorMessage` and the toast
 * system are out of reach and every failure used to reach the user through
 * `alert()` -- which blocks the page, looks like a browser fault rather than
 * part of the product, and carried whatever string the upstream library
 * happened to produce ("Signups not allowed for otp").
 *
 * The wording rule matches the one `api/` handlers already follow (#175 M-1):
 * the detail goes to the console for whoever is debugging, and the user reads
 * something written for them.
 */ /** Styling kept in one place so the three pages cannot drift apart. */ const $bfd825a8004fc601$var$ERROR_CLASSES = [
    "text-sm",
    "rounded-md",
    "px-3",
    "py-2",
    "border-2",
    "text-center",
    "mt-5",
    "text-red-600",
    "border-red-600"
];
function $bfd825a8004fc601$export$5f42f100f752a07c(container, message, detail) {
    if (detail !== undefined) console.error(message, detail);
    $bfd825a8004fc601$export$f96a15e9c4403cf2(container);
    const paragraph = document.createElement("p");
    paragraph.dataset.formError = "true";
    paragraph.setAttribute("role", "alert");
    paragraph.classList.add(...$bfd825a8004fc601$var$ERROR_CLASSES);
    paragraph.textContent = message;
    container.append(paragraph);
}
function $bfd825a8004fc601$export$f96a15e9c4403cf2(container) {
    container.querySelector("[data-form-error]")?.remove();
}
function $bfd825a8004fc601$export$900aa99cc481764f() {
    return [
        ...$bfd825a8004fc601$var$ERROR_CLASSES.filter((c)=>c !== "mt-5"),
        "mb-5"
    ];
}
function $bfd825a8004fc601$export$51d2406237757203(box, message) {
    box.querySelector("[data-box-notice]")?.remove();
    const paragraph = document.createElement("p");
    paragraph.dataset.boxNotice = "true";
    paragraph.setAttribute("role", "alert");
    paragraph.classList.add(...$bfd825a8004fc601$export$900aa99cc481764f());
    paragraph.textContent = message;
    box.prepend(paragraph);
}

});


var $5DLox = parcelRequire("5DLox");
function $b4142f1f6a734bc5$export$d584964c9b65b738(origin) {
    return {
        provider: "google",
        options: {
            redirectTo: `${origin}/auth/callback/`
        }
    };
}



var $8C6MA = parcelRequire("8C6MA");
// Included on the homepage, /login/ and /register/ via the google-signin
// partial. Guarded so it is a no-op if the button is absent.
const $abe06d8f0f723291$var$button = document.getElementById("googleButton");
$abe06d8f0f723291$var$button?.addEventListener("click", ()=>{
    (async ()=>{
        const { error: error } = await (0, $5DLox.supabase).auth.signInWithOAuth((0, $b4142f1f6a734bc5$export$d584964c9b65b738)(window.location.origin));
        // On success supabase performs a top-level redirect to Google; we only get
        // here on failure to start the flow.
        if (error) // Shown beside the button rather than in an alert, and without the
        // upstream wording -- which is written for whoever wrote the SDK.
        (0, $8C6MA.showFormError)($abe06d8f0f723291$var$button.parentElement ?? document.body, "Could not start Google sign-in. Please try again.", error);
    })();
});


//# sourceMappingURL=path0.82846405.js.map
